const SectionTitle = ({ eyebrow, children }) => (
  <div className="mb-4 flex items-center gap-3">
    <span className="h-6 w-1.5 rounded-full bg-brand-500" />
    <div>
      {eyebrow && (
        <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
          {eyebrow}
        </p>
      )}
      <h2 className="text-xl font-bold text-navy-700 dark:text-white">{children}</h2>
    </div>
  </div>
);

export default SectionTitle;
